import React from "react";
import { connect } from "react-redux";

const Loading = (props) => {
   const { loading } = props;
   return (
      <React.Fragment>
         {loading &&
            <section className="wrapper-loading">
               <div className="loader">
                  <div className="loading one"></div>
                  <div className="loading two"></div>
                  <div className="loading three"></div>
                  <div className="loading four"></div>
               </div>
            </section>
         }
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   const { loading } = state;

   return {
      loading
   };
};

export default connect(mapStateToProps, {
})(Loading);